import { Box, Chip, useTheme } from "@mui/material";
import { tokens } from "../theme";

// Moksha Stays brand sage, taken from the wordmark. Deliberately not greenAccent -
// that already means "active / confirmed" in this dashboard, and channel is not status.
const SAGE_DARK = "#9CC5B4";
const SAGE_LIGHT = "#4F7D69";

const useSage = () => (useTheme().palette.mode === "dark" ? SAGE_DARK : SAGE_LIGHT);

// Letterspaced caps echo the "STAYS" lockup under the wordmark.
export const MokshaBadge = ({ size = "md" }) => {
  const sage = useSage();
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        whiteSpace: "nowrap",
        color: sage,
        border: `1px solid ${sage}59`,
        backgroundColor: `${sage}1f`,
        borderRadius: "999px",
        padding: size === "sm" ? "1px 7px" : "2px 9px",
        fontSize: size === "sm" ? "0.6rem" : "0.65rem",
        fontWeight: 700,
        letterSpacing: "0.14em",
        textTransform: "uppercase",
        lineHeight: 1.7,
      }}
    >
      Moksha
    </Box>
  );
};

// Stands in for a value the viewer was not shown. Reads the same as any other "no
// value" chip in this dashboard - no tooltip, no styling that marks it as different
// from a field that simply has nothing in it.
export const HiddenValue = () => {
  const colors = tokens(useTheme().palette.mode);
  return (
    <Chip
      size="small"
      variant="outlined"
      label="N/A"
      // Inline: this sits inside a Typography or a ListItemText at every call site, and a
      // div nested in their p/span is invalid markup.
      component="span"
      sx={{ color: colors.grey[400], borderColor: colors.grey[600] }}
    />
  );
};
